import React, { useCallback, useMemo } from "react";

import { faBoltLightning, faBuilding, faEarthAmerica, faMars, faQuestion, faVenus, faVenusMars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ExploreStatsEnum } from "@/enum/common";
import { commaSeperatorFormat, convertToPercentage, formatAsPercentage } from "@/helpers/common";
import { ISummaryData } from "@/types/Filters";

interface ITextChart {
    data: ISummaryData;
    isLoading: boolean;
}
function TextChart({ data, isLoading }: ITextChart) {

    const getIcon = useCallback(() => {
        switch (data.name.trim()) {
            case ExploreStatsEnum.activeCompanies:
                return faBuilding;
            case ExploreStatsEnum.maleLed:
                return faMars;
            case ExploreStatsEnum.femaleLed:
                return faVenus;
            case ExploreStatsEnum.mixed:
                return faVenusMars;
            case ExploreStatsEnum.unknown:
                return faQuestion;
            case ExploreStatsEnum.ethnicMaleLed:
            case ExploreStatsEnum.ethnicFemaleLed:
            case ExploreStatsEnum.ethnicMixedLed:
            case ExploreStatsEnum.ethnicUnknownLed:
                return faEarthAmerica;
            case ExploreStatsEnum.maleLedGrowth:
            case ExploreStatsEnum.femaleLedGrowth:
            case ExploreStatsEnum.mixedLedGrowth:
            case ExploreStatsEnum.unknownLedGrowth:
                return faBoltLightning;
            default:
                return faBuilding;
        }
    }, [data.name]);

    const getTitle = useCallback(() => {
        switch (data.name.trim()) {
            case ExploreStatsEnum.activeCompanies:
                return "Total active companies";

            case ExploreStatsEnum.maleLed:
                return ExploreStatsEnum.maleLed.replace(" companies", "");
            case ExploreStatsEnum.ethnicMaleLed:
                return ExploreStatsEnum.ethnicMaleLed.replace(" companies", "");
            case ExploreStatsEnum.maleLedGrowth:
                return ExploreStatsEnum.maleLedGrowth.replace(" companies", "");

            case ExploreStatsEnum.femaleLed:
                return ExploreStatsEnum.femaleLed.replace(" companies", "");
            case ExploreStatsEnum.ethnicFemaleLed:
                return ExploreStatsEnum.ethnicFemaleLed.replace(" companies", "");
            case ExploreStatsEnum.femaleLedGrowth:
                return ExploreStatsEnum.femaleLedGrowth.replace(" companies", "");

            case ExploreStatsEnum.mixed:
                return ExploreStatsEnum.mixed.replace(" companies", "");
            case ExploreStatsEnum.ethnicMixedLed:
                return ExploreStatsEnum.ethnicMixedLed.replace(" companies", "");
            case ExploreStatsEnum.mixedLedGrowth:
                return ExploreStatsEnum.mixedLedGrowth.replace(" companies", "");

            case ExploreStatsEnum.unknown:
                return ExploreStatsEnum.unknown.replace(" companies", "");
            case ExploreStatsEnum.ethnicUnknownLed:
                return ExploreStatsEnum.ethnicUnknownLed.replace(" companies", "");
            case ExploreStatsEnum.unknownLedGrowth:
                return ExploreStatsEnum.unknownLedGrowth.replace(" companies", "");
            default:
                return data.name;
        }
    }, [data.name]);

    const gp = useMemo(() => {
        if (!data.gender_percentage) {
            return "";
        }
        const t = convertToPercentage(data.gender_percentage);
        return t.includes(".00") ? (Number(data.gender_percentage) * 100).toFixed(2) : t;

    }, [data.gender_percentage]);
    if (isLoading) {
        return null;
    }

    return (
        <div className='chartDataTile'>
            <div className="chartDataContainer">
                <div className="chartDataIcon">
                    <FontAwesomeIcon icon={getIcon()} />
                </div>

                <div className='infoWrap'>
                    <div className='name'>{getTitle()}</div>
                    {
                        !isLoading
                        && <div className="chartDataStats">
                            <div className='percentCount'>
                                {data.number === 0 || !data ? formatAsPercentage(0) : commaSeperatorFormat(data.number)}
                            </div>
                            {
                                (!isLoading)
                                && <div className='percentWrap'>
                                    {
                                        data.gender_percentage === 0 || !data
                                            ? formatAsPercentage(0)
                                            : formatAsPercentage(gp.replace(/\.00$/, "") as any)
                                    }
                                </div>
                            }
                        </div>
                    }

                </div>
            </div>

        </div>
    );
}

export default TextChart;
